import React, { PureComponent } from 'react';
import { decamelizeKeys } from 'humps';
import { Redirect } from 'react-router';
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { callApi } from '../../middleware/api';
import { Input } from '../../components/Form';
import Alert from '../../components/Form/Alert';
import { createValidator, required, email } from '../../components/Form/validators';


class From extends PureComponent {
  render() {
    const { handleSubmit, invalid, error, submitting } = this.props;
    return (
      <form className="mt-3 col-lg-7" onSubmit={handleSubmit} noValidate>
        {error && <Alert>{error}</Alert>}
        <Field component={Input} type="email" name="email" label="E-pasts" />
        <button 
          className="btn pull-right btn-primary btn-lg"
          disabled={invalid || submitting }
          type="submit"
        >
          Turpināt
        </button>
    </form>
    );
  }
}

const validate = createValidator({
  email: [required, email]
});

const RequestFrom = reduxForm({
  form: 'reset_request',
  validate,
})(From);

export default class Request extends PureComponent {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = { success: false };
  }

  handleSubmit(values) {
    return callApi('reset/request/', undefined, "POST", decamelizeKeys(values))
      .then(
        resp => this.setState({ success: true }),
        ({response, json}) => { throw new SubmissionError({_error: json }); }
      );
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/reset/success/" />
    }

    return (
      <div className="container mt-5">
        <h1>Mainīt paroli</h1>
        <div className="row">
          <RequestFrom onSubmit={this.handleSubmit} />
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Reset/Request.js